//@ts-nocheck
import {
  applySnapshot,
  cast,
  flow,
  getEnv,
  getParent,
  getSnapshot,
  hasParent,
  Instance,
  types,
} from "mobx-state-tree";
import { gradeQuiz } from "./quiz-grader";

const SubmittedAnswer = types.model("SubmittedAnswer", {
  question: types.number,
  answer: types.optional(types.string, ""),
});

const Answer = types.model("Answer", {
  content: types.union(types.string, types.number),
  figure: types.maybeNull(types.string),
  correct: types.optional(types.boolean, false),
  answer_type: types.optional(types.string, ""),
});

const Comprehension = types.model("Comprehension", {
  passage: types.string,
  kind: types.maybeNull(types.string),
});

export const Question = types
  .model("Question", {
    id: types.number,
    content: types.string,
    questionIndex: types.optional(types.number, 0),
    subject: types.optional(types.string, ""),
    title: types.optional(types.string, ""),
    figure: types.maybeNull(types.string),
    comprehension: types.maybeNull(Comprehension),
    options_display: types.optional(types.string, ""),
    question_type: types.optional(types.string, ""),
    // options_display: types.optional(types.enumeration("OptionDisplay",["horizontal","vertical"]),"horizontal"),
    answers: types.optional(types.array(Answer), []),
  })
  .views((self) => {
    return {
      get correctAnswer() {
        const alpha = ["A", "B", "C", "D", "E", "F", "G", "H"];
        const index = self.answers.findIndex((x) => x.correct);
        return alpha[index];
      },
    };
  });

const Quiz = types.model("Quiz", {
  title: types.optional(types.string, ""),
  type: types.optional(types.string, ""),
  questions: types.optional(types.array(Question), []),
  description: types.optional(types.string, ""),
  slug: types.optional(types.string, ""),
  pass_mark: types.optional(types.number, 0),
  requires_calculator: types.optional(types.boolean, false),
  duration: types.optional(types.number, 0),
});

const QuizResult = types.model("QuizResult", {
  questionsAnswered: types.optional(types.number, 0),
  completionRate: types.optional(types.number, 0),
  totalQuizGrade: types.optional(types.number, 0),
  passRate: types.optional(types.number, 0),
  correctAnswers: types.optional(types.number, 0),
  passedQuiz: types.optional(types.boolean, false),
});

const Subject = types.model("Subject", {
  name: types.optional(types.string, ""),
  pass_mark: types.number,
  test_name: types.optional(types.string, ""),
  test_sheet_id: types.maybeNull(types.number),
  url: types.optional(types.string, ""),
});
const FlaggedQ = types.model("FlaggedQ", {
  subject: types.optional(types.string, ""),
  questions: types.optional(types.number, 0),
});

const QuizStore = types
  .model("QuizStore", {
    quiz: types.optional(Quiz, {}),
    _canTakeQuiz: types.optional(types.boolean, true),
    currentQ: types.optional(types.number, 1),
    answers: types.optional(types.array(SubmittedAnswer), []),
    loading: types.optional(types.boolean, false),
    testSubject: types.optional(types.string, ""),
    quizResults: types.optional(QuizResult, {}),
    subjectsToTake: types.optional(types.array(Subject), []),
    completed: types.optional(types.boolean, false),
    flaggedQuestions: types.optional(types.array(FlaggedQ), []),
  })
  .views((self) => {
    return {
      get flaggedQ() {
        let subjects = [
          ...new Set(self.flaggedQuestions.map((o) => o.subject)),
        ];
        return subjects.map((j) => {
          let q = self.flaggedQuestions
            .filter((u) => u.subject === j)
            .map((y) => y.questions);
          return {
            subject: j,
            questions: [...new Set(q)],
          };
        });
      },
      currentIndex() {
        return self.currentQ - 1;
      },
      get questions() {
        return self.quiz.questions;
      },
      get question() {
        return this.questions[this.currentIndex()];
      },
      get currentAnswer() {
        return this.formattedAnswers[String(self.currentQ)];
      },
      get lastQuestion() {
        // if (hasParent(self)) {
        //   const parent: any = getParent(self, 1);
        //   return parent.totalQuestionCount;
        // } else {
        return this.questions.length;
        // }
      },

      get formattedAnswers() {
        const result: { [key: string]: any } = {};
        self.answers.forEach((x) => {
          result[x.question] = x.answer;
        });
        return result;
      },
      findCurrentQuestionInAnswers() {
        if (self.answers.length === 0) {
          return -1;
        }
        for (let index = 0; index < self.answers.length; index++) {
          if (self.currentQ === self.answers[index].question) {
            return index;
          }
        }
        return -1;
      },
      //   get unansweredQs() {
      //     const answeredQuestions = Object.keys(this.formattedAnswers).map(
      //       (num) => parseInt(num)
      //     );
      //     const allQuestions = self.questions.map((_, index) => index + 1);
      //     const unansweredQuestions = allQuestions.filter((num) =>
      //       answeredQuestions.includes(num)
      //     );
      //     return unansweredQuestions;
      //   },
      get unansweredQs() {
        const answeredQuestions = Object.keys(this.formattedAnswers).map(
          (num) => parseInt(num),
        );
        const allQuestions = this.questions.map((_, index) => index + 1);
        const answeredQs = allQuestions.filter((num) =>
          answeredQuestions.includes(num),
        );
        let unansweredQuestions = Array(this.questions.length)
          .fill(1)
          .map((item, index) => index + 1)
          .filter((q) => !answeredQs.includes(q));
        return unansweredQuestions;
      },

      get getQuizDescription() {
        return "";
        // const { title, type } = self;
        // if (type) return `${title} test - ${type}`;
        // return title;
      },

      get serverAnswerFormat() {
        // [{question: 1, answer: "C"}]
        const answers = self.answers.map((answer) => {
          let question_index = answer.question - 1;
          let question = self.quiz.questions[question_index];
          const answerMapping = {
            A: 0,
            B: 1,
            C: 2,
            D: 3,
          };
          return {
            question_id: question.id,
            answer: answerMapping[answer.answer],
          };
        });
        return answers;
      },

      get subjects() {
        return self.subjectsToTake.map((subject) => subject.name);
      },
      get avg_passmark() {
        const sum = self.subjectsToTake.reduce(
          (sum, subject) => sum + subject.pass_mark,
          0,
        );
        const avg = sum / self.subjectsToTake.length;
        return avg;
      },
    };
  })
  .actions((self) => {
    const { adapter } = getEnv(self);
    // const getResult = flow(function* (data: any) {
    // 	const parent: any = getParent(self, 2);
    // const results = Object.keys(data).map((key) => {
    // 	return { question: parseInt(key), answer: data[key] as string };
    // });

    // 	self.answers = cast(results);
    // 	if (parent) {
    // 		try {
    // 			yield parent.postResults();
    // 		} catch (error) {
    // 			throw error;
    // 		}
    // 	}
    // });

    // const getQuestionsForNextPage = flow(function* getQForNextPage() {
    // 	try {
    // 		if (self.currentQ < self.lastQuestion) {
    // 			self.loading = true;
    // 			if (hasParent(self)) {
    // 				yield onCurrentQuestion(self.currentQ + 1);
    // 				self.currentQ += 1;
    // 				self.loading = false;
    // 				yield getResult(self.formattedAnswers());
    // 			} else {
    // self.currentQ += 1;
    // self.loading = false;
    // 			}
    // 		}
    // 	} catch (error) {
    // 		throw error;
    // 	}
    // });

    // const getLastAnsweredQuestion = flow(function* getLastAnsweredQuestion(course: string, subject: string) {
    // 	try {
    // 		const {adapter} = getEnv(self)
    // 		const status = yield adapter.getLastAnsweredQuestion(course, subject)
    // 		const keys = Object.keys(status)
    // 		const lastQuestion = keys[keys.length - 1]
    // 		self.currentQ = parseInt(lastQuestion)
    // 	} catch (error) {
    // 		throw error;
    // 	}
    // });

    const handleSubmission = flow(function* onCompleteQuiz(quizzes) {
      try {
        let gradedResult = gradeQuiz(
          quizzes,
          self.serverAnswerFormat,
          self.quiz.questions.length,
          getSnapshot(self.subjectsToTake),
        );
        let data = self.formattedAnswers;
        const results = Object.keys(data).map((key) => {
          return { question: parseInt(key), answer: data[key] as string };
        });
        // const response = yield adapter.postResults(self.serverAnswerFormat, self.testSubject);
        const response = yield adapter.postResults(
          self.testSubject,
          gradedResult,
          self.flaggedQ,
        );
        self.answers = cast(results);
        applySnapshot(self.quizResults, gradedResult);
        self.completed = true;
        return response;
      } catch (error) {
        throw error;
      }
    });
    return {
      flagQuestion(question: any) {
        self.flaggedQuestions.push({
          subject: question.subject,
          questions: question.questionIndex + 1,
        });
      },
      // getLastAnsweredQuestion,
      initializeQuizQuestions({ questions }: { questions: Array<any> }) {
        applySnapshot(self.questions, questions);
      },
      initializeQuiz(quiz: any, subjectsToTake: any[]) {
        self.subjectsToTake = cast(JSON.parse(JSON.stringify(subjectsToTake)));
        self.quiz = quiz;
        self.testSubject = quiz.title;
      },
      handleSubmission,
      nextQuestion() {
        self.currentQ += 1;
        self.loading = false;
      },
      previousQuestion() {
        if (self.currentQ > 1) {
          self.currentQ -= 1;
          return true;
        }
      },
      setAnswers(option: any) {
        const index = self.findCurrentQuestionInAnswers();
        if (index < 0) {
          self.answers.push({
            question: self.currentQ,
            answer: option,
          });
        } else {
          self.answers[index].answer = option;
        }
      },
      setCurrentQ(num: number) {
        self.currentQ = num;
      },

      setTestSubject(subject) {
        self.testSubject = subject;
      },

      setQuizResults(res) {
        applySnapshot(self.quizResults, res);
      },

      // setLastAnswer(course: string, subject:any) {
      // 	const parent: any = getParent(self, 1);
      // 	const answeredQuestions = parent.currentAssignedSubject.quiz.answers;
      // 	if (answeredQuestions.length > 0) {
      // 		const lastQuestion =
      // 			answeredQuestions[answeredQuestions.length - 1].question;
      // 		parent.currentAssignedSubject.quiz.setCurrentQ(lastQuestion);
      // 	}
      // },
      // setLastAnswer(answers: any) {
      // 		const keys = Object.keys(answers)
      // 		console.log(keys)
      // 		return keys
      // },

      processAnswers() {},
      setSubjectsToTake(subjects: any) {
        self.subjectsToTake = cast(subjects);
      },
      setCompleted(value) {
        self.completed = value;
      },
    };
  });

export interface IQuizStore extends Instance<typeof QuizStore> {}
export interface IQuestionStore extends Instance<typeof Question> {}

export default QuizStore;
